import { render, staticRenderFns } from "./shopgoodsdetail.vue?vue&type=template&id=02693247&scoped=true&"
import script from "./shopgoodsdetail.vue?vue&type=script&lang=ts&"
export * from "./shopgoodsdetail.vue?vue&type=script&lang=ts&"
import style0 from "./shopgoodsdetail.vue?vue&type=style&index=0&id=02693247&scoped=true&lang=css&"
import style1 from "./shopgoodsdetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02693247",
  null
  
)

export default component.exports